import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppSettings } from './../../app.settings';
import { StorageService } from './../../services/storage.service';
import { SidebarService } from './../../services/sidebar.service';
import { Subscription } from 'rxjs';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { UserCommonService } from '../../services/user-common.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {
  items: MenuItem[];
  subscription: Subscription;
  sidebarToggleSubscription: Subscription;
  isMultipleTabOpen: any = false;
  user;

  updateType: any;
  displayVersion: any = '';
  currentVersion: any = '';
  newVersion: any = '';
  latestVersionObj: any = '';
  whatsNew: any = '';
  isUpdateAvailable = false;
  AppVersionHistoryRefreshInterval;
  buildVersion: any;

  constructor(
    private storageService: StorageService,
    private sidebarService: SidebarService,
    private commonBindingDataService: CommonBindingDataService,
    private cdr: ChangeDetectorRef,
    private uiService: UiService,
    public userCommonService: UserCommonService,
  ) { }


  ngOnInit() {
    this.initSidebarItems();
    this.subscription = this.sidebarService.sideState
      .subscribe((state: any) => {
        this.updateItems(state);
      });

    this.commonBindingDataService.redrawSidebar.subscribe(() => {
      this.initSidebarItems();
    });

    this.sidebarToggleSubscription = this.uiService.sidebarToggledEvent.subscribe(() => {
      this.syncMenuTooltips();
    });

        this.buildVersion = this.storageService.getItem(AppSettings.WEB_VERSION);
    if (this.buildVersion) {
      this.displayVersion = this.buildVersion.version;
      this.currentVersion = this.buildVersion.version;
      this.cdr.detectChanges();
      this.AppVersionHistoryRefreshInterval = setInterval(() => {
       this.getWebAppVersion();
     }, 60000 * 24);
    }
  }

  initSidebarItems() {
    this.items = [];
    this.user = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.items.length <= 0) {
      if (this.user !== null && this.user !== undefined) {
        this.items = this.getMenu();
      }
    }
    this.updateItems();
    this.manageActiveStatus();
    this.syncMenuTooltips();
  }

  updateItems(state?) {
    if (state) {
      this.items = state;
    }
    this.items = this.removeDuplicates(this.items, 'label');
    this.syncMenuTooltips();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.sidebarToggleSubscription?.unsubscribe();
    if (this.AppVersionHistoryRefreshInterval) {
      clearInterval(this.AppVersionHistoryRefreshInterval);
    }
  }

  private isSidebarCollapsed(): boolean {
    return document.body.classList.contains('closed');
  }

  private syncMenuTooltips(): void {
    if (!this.items?.length) {
      return;
    }
    this.applyMenuTooltips(this.items, this.isSidebarCollapsed());
    this.items = [...this.items];
    this.cdr.detectChanges();
  }

  private applyMenuTooltips(items: MenuItem[], show: boolean): void {
    items.forEach((item) => {
      if (show) {
        item.title = item.label;
        item.tooltip = item.label;
        item.tooltipOptions = { tooltipPosition: 'right' };
      } else {
        delete item.title;
        delete item.tooltip;
        delete item.tooltipOptions;
      }
      if (item.items?.length) {
        this.applyMenuTooltips(item.items, show);
      }
    });
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }


  private manageActiveStatus() {
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      if (item.routerLink) {
        if (item.routerLink.length >= 1 && document.location.pathname === item.routerLink[0]) {
          item.expanded = true;
        }
      }
    }
  }

  selectedMenuClick(item) {
    this.storageService.setItem('selectedMenu', item.srcElement.textContent.trim());
  }

  getMenu() {
    return this.sidebarService.sideBarMenu;
  }

  
  getWebAppVersion() {
    this.commonBindingDataService.getWebAppVersion().subscribe({
      next: (result) => {
        if (this.buildVersion.version !== result.version) {
          if (result.mandatory === true || result.optional === true) {
            this.isUpdateAvailable = true;
            this.updateType = result.updateType;
            this.latestVersionObj = result;
            this.newVersion = result.version;
            this.whatsNew = result.updateDetails;
          }
          }
        },
      error: (error) => {
        // this.uiService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
      }
    })
  }

  updateNow() {
    this.isUpdateAvailable = false;
    this.storageService.setItem(AppSettings.WEB_VERSION, this.latestVersionObj);
    location.reload();
  }

  updateSkipNow() {
    this.isUpdateAvailable = false;
  }


}
